<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__orderedList">mdi-format-list-numbered</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'orderedList',
  methods: {
    onClick () {
      this.$emit('click', 'insertOrderedList')
    }
  }
}
</script>

<style scoped>
#RTE__command__orderedList {
  font-size: 20px;
}
</style>
